import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';

export default class InvoiceDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });
    this.state = {
      columns: [
        { title: 'ID', field: 'id', editable: 'never', width: 10, grouping: false },
        { title: 'Item', field: 'item', editable: 'never' },
        { title: 'Amount', field: 'amount', editable: 'never', grouping: false },
        { 
          title: 'Status', 
          field: 'status',
          lookup: { 'pending': 'pending', 'paid': 'paid', 'unpaid': 'unpaid', 'rejected':'rejected' }
        },
        { title: 'Profile', field: 'profile_name', editable: 'never' },
        { title: 'Ref Number', field: 'ref_number', editable: 'never', grouping: false },
        { title: 'Source', field: 'source', editable: 'never' },
        { title: 'Date', field: 'created_at', editable: 'never', grouping: false },
        
      ],
      data: [],
      page: null,
      open: false,
      totalCount: null
    }
  }

  fetchData(query){
    return new Promise((resolve, reject) => {
      let url = '/api/invoices?'
      console.log('params', query)
      url += 'per_page=' + query.pageSize
      url += '&q=' + query.search
      url += '&page=' + (query.page + 1)
      fetch(url)
        .then(res => (res && res.status === 200 && res.ok ? res.json() : Promise.reject(res)))
        .then(data => {
          // console.log('row data', data.insurances)
          // console.log('total count', data.pagination.count)
          resolve({
            data: data.invoices,
            page: data.pagination.page - 1,
            totalCount: data.pagination.count
          })
          // this.setState({
          //   data: data.insurances,
          //   page: data.pagination.page - 1,
          //   totalCount: data.pagination.count
          // });
        })
    })
  }

  render() {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title="Invoices"
          columns={this.state.columns}
          tableRef={this.tableRef}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            }
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 30, 50],
            exportButton: true,
            sorting: true,
            search: true,
            grouping: true,
          }}
          onRowClick={(event, rowData) => Turbolinks.visit(rowData.url)}
          data={query =>
            this.fetchData(query)
          
          }
          // editable={{
          //   onRowUpdate: (newData, oldData) =>

          //     new Promise((resolve, reject) => {
          //       console.log('id is', newData.slug);
          //       const csrfToken = document.querySelector('[name=csrf-token]').content
          //       setTimeout(() => {
          //         {
          //           return fetch(`/api/invoices/${newData.slug}`, {
          //             method: 'PUT',
          //             body: JSON.stringify(newData),
          //             headers: {
          //               "Content-type": "application/json; charset=UTF-8",
          //               'X-CSRF-Token': csrfToken
          //             }
          //           }).then(response => {
          //             return response.json()
          //           }).then(result => {
          //             console.log(result)
          //             const data = this.state.data;
          //             const index = data.indexOf(oldData);
          //             data[index] = newData;
          //             this.setState({ data }, () => resolve());
          //           })
                      
          //         }
          //         resolve()
          //       }, 350)
          //     }),
            
          // }}
        />
      </MuiThemeProvider>
    )
  }

}

